<template>
    <div class="search_detail">
        <form action="/">
          <van-search
            v-model="keywords"
            
            placeholder="请输入搜索关键词"
            @input="onSearch"
            @cancel="onCancel"
        />
        </form>
        <van-tabs v-model="active" v-if="!nullData" color="#901d22">
            <van-tab title="综合" >
                <div>
                    <!-- 品牌 -->
                    <div v-if="brandList.length>0">
                        <div class="wrap">
                            <h1>品牌</h1>
                            <brand :list="brandList"></brand>
                            <div class="more">
                                <a href="javascript:voild(0)" @click="skipTab(1)">
                                    <span>查看更多品牌</span>
                                    <van-icon name="arrow" />
                                </a>
                            </div>
                        </div>
                        <div class="gray-10" ></div>
                    </div>
                    <!-- 器械  -->
                    <div v-if="instrumentList.length>0">
                        <div class="wrap" >
                            <h1>器械</h1>
                            <apparatus :list="instrumentList"></apparatus>
                            <div class="more">
                                <a href="javascript:voild(0)" @click="skipTab(2)">
                                    <span>查看更多器械</span>
                                    <van-icon name="arrow" />
                                </a>
                            </div>
                        </div>
                        <div class="gray-10" ></div>
                    </div>
                    <!-- 文章  -->
                    <div class="wrap" v-if="articleList.length>0">
                        <h1>文章</h1>
                        <div>
                            <template v-for="(item,index) in articleList" v-show="index<=2">
                                <item-block :itemContent="item" :searchType="3" :key="item.id"></item-block>
                            </template>
                        </div>
                        <div class="more">
                            <a href="javascript:voild(0)" @click="skipTab(3)">
                                <span>查看更多文章</span>
                                <van-icon name="arrow" />
                            </a>
                        </div>
                    </div>
                </div>
            </van-tab>
            <van-tab title="品牌">
                <div class="wrap" v-if="brandList.length>0">
                    <brand :list="brandList"></brand>
                </div>
                <p class="noData" v-else>
                    暂无“<span>{{keywords}}</span>”相关搜索结果
                </p>
            </van-tab>
            <van-tab title="器械">
                <div class="wrap" v-if="instrumentList.length>0">
                    <apparatus :list="instrumentList"></apparatus>
                </div>
                <p class="noData" v-else>
                    暂无“<span>{{keywords}}</span>”相关搜索结果
                </p>
            </van-tab>
            <van-tab title="文章">
                <div class="wrap" v-if="articleList.length>0">
                    <template v-for="(item) in articleList">
                        <item-block :itemContent="item" :searchType="3" :key="item.id"></item-block>
                    </template>
                </div>
                <p class="noData" v-else>
                    暂无“<span>{{keywords}}</span>”相关搜索结果
                </p>
            </van-tab>
        </van-tabs> 
        <van-empty image="search" description="暂无任何数据" v-else/>   
    </div>
</template>
<script>
import ColumnItemBlock from '../../components/ColumnItemBlock.vue'
import ExpertInfo from '../../components/Expert/ExpertInfo.vue'
import ItemBlock from '../../components/ItemBlock.vue';
import Brand from './Components/Brand';
import Apparatus from './Components/apparatus';
import {InstrumentSearch} from '@/config/interface.js';
export default {
    components:{
        ExpertInfo,
        ColumnItemBlock,
        ItemBlock,
        Brand,
        Apparatus,
    },
    data(){
        return{
            active:0,
            keywords:'',
            historyWords:[],     //历史搜索
            tabsTitle:null,     
            brandList:[],      //品牌
            instrumentList:[], //器械
            articleList:[],
            nullData:true,
        }
    },
    mounted(){
        this.getHistoryWords();
		//微信浏览器  请求jsdk
		if(common.is_weixin()){
			common.moduleDetails(5);
		}
    },
    methods:{
		//获取输入框里输入的关键词
		searchInput(){
			this.keywords=(this.keywords).replace(/(^\s*)|(\s*$)/g, '');
			console.log(this.keywords);
		},
		//获取本地存储的关键词
		getHistoryWords(){
			let historyWords=localStorage.getItem('historyWords');
			if(historyWords){
				this.historyWords=JSON.parse(historyWords);
			}else{
				this.historyWords=[];
			}
        },
		//点击搜索的标签
		clickKeyWord(word){
			this.keywords=word;
			this.onSearch();
		},
        //搜索
        onSearch(){
            if(this.keywords!=''){
                const url=InstrumentSearch;
                const method='POST';
                let params={
                    keyword:this.keywords
                }
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        let data=res.data;
                        this.tabsTitle=data.head;
                        console.log(this.tabsTitle)
                        this.brandList=data.result['品牌'];
                        this.instrumentList=data.result['器械'];
                        this.articleList=data.result['相关文章'];
                        this.nullData=this.brandList.length<0&&this.brandList.length<0&&this.brandList.length<0?true:false;
                    
                    }else if(res.code==401){
                        this.nullData=true;
                    }
                })
            }else{
                this.nullData=true;
            }

        },
        //取消
        onCancel(){
            // this.keywords='';
            // this.onSearch();
        },
        //跳转tab
        skipTab(active){
            this.active=active;
        }
    }
}
</script>
<style lang="scss" scoped>
    .search_detail{
        .gray-10{
            width:100%;
            height:10px;
            background-color:#efefef;
        }
        // .history{
        //     padding:0 14px 10px;
        //     .history-item{
        //         display:flex;
        //         padding:8px 0;
        //         justify-content: space-between;
        //         align-items: center;
        //         border-bottom:1px solid #ddd;
        //         .name{
        //             font-size:15px;
        //             color:#666;
        //             display:flex;
        //             align-items: center;
        //             i{
        //                 margin-right:5px;
        //             }
        //         }
        //     }
        //     >.history-item:last-child{border:0px};
        // }
        .noData{
            text-align: center;
            font-size:17px;
            letter-spacing: 1px;
            margin-top:15px;
            span{
                color:#901d22;
            }
        }
        .wrap{
            padding:14px 14px 0;
            h1{
                font-size:16px;
                font-weight: normal;
                color:#999;
            }
            .more{
                text-align: right;
                padding:10px 0;
                a{
                    display: inline-block;
                    font-size:15px;
                    color:#666;
                    i{
                        display: inline-block;
                        vertical-align: -2px;
                    }
                }
            }
        }

    }
</style>


// WEBPACK FOOTER //
// src/pages/Instrument/search.vue